import React, { Dispatch, SetStateAction } from "react"
import Modal from "../../../../components/Modal"
import { UserPaymentFilters } from "../types"
import DateInput from "../../../User/getAllUsers/components/DateInput"
import TextInput from "../../../User/getAllUsers/components/TextInput"

interface FiltersProps {
  isOpen: boolean
  onClose: () => void
  filters: UserPaymentFilters
  setFilters: Dispatch<SetStateAction<UserPaymentFilters>>
  handleFetchData: () => Promise<void>
}

const Filters: React.FC<FiltersProps> = ({
  isOpen,
  onClose,
  filters,
  setFilters,
  handleFetchData,
}) => {
  type FilterKey = Extract<keyof UserPaymentFilters, string>
  const statusOptions = ["", "PENDING", "SUCCESS", "DENIED", "FAILED", "REQUESTED"]

  const handleClear = () => {
    setFilters((prev) => ({
      ...prev,
      dateStart: "",
      dateEnd: "",
      targetDateStart: "",
      targetDateEnd: "",
      paymentDateStart: "",
      paymentDateEnd: "",
      lastPaymentTryStart: "",
      lastPaymentTryEnd: "",
      name: "",
      surname: "",
      id_number: "",
      status: "",
    }))
  }

  const handleChange = (key: FilterKey, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  return (
    <>
      {isOpen && (
        <div className="flex w-full items-center justify-center">
          <Modal
            classname="fixed inset-0 bg-gray-800 bg-opacity-50 p-3 flex items-center justify-end z-50"
            classname2="relative bg-white rounded-3xl w-full md:w-1/2 max-h-[90vh]"
            onClick={onClose}
          >
            <div className="w-full p-4 max-h-[90vh] overflow-y-auto overscroll-contain">
              <div className="w-full">
                <h2 className="font-semibold text-2xl">Filtrele</h2>
                <div className="border"></div>
              </div>

              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <DateInput
                  value={filters.dateStart || ""}
                  setValue={(e) => setFilters({ ...filters, dateStart: e })}
                  placeholder="Tarih Aralığı Başlangıcı"
                />
                <DateInput
                  value={filters.dateEnd || ""}
                  setValue={(e) => setFilters({ ...filters, dateEnd: e })}
                  placeholder="Tarih Aralığı Bitişi"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <DateInput
                  value={filters.targetDateStart || ""}
                  setValue={(e) => setFilters({ ...filters, targetDateStart: e })}
                  placeholder="Hedeflenen Tarih Başlangıcı"
                />
                <DateInput
                  value={filters.targetDateEnd || ""}
                  setValue={(e) => setFilters({ ...filters, targetDateEnd: e })}
                  placeholder="Hedeflenen Tarih Bitişi"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <DateInput
                  value={filters.paymentDateStart || ""}
                  setValue={(e) => setFilters({ ...filters, paymentDateStart: e })}
                  placeholder="Ödeme Tarihi Başlangıcı"
                />
                <DateInput
                  value={filters.paymentDateEnd || ""}
                  setValue={(e) => setFilters({ ...filters, paymentDateEnd: e })}
                  placeholder="Ödeme Tarihi Bitişi"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <DateInput
                  value={filters.lastPaymentTryStart || ""}
                  setValue={(e) => setFilters({ ...filters, lastPaymentTryStart: e })}
                  placeholder="Son Ödeme Denemesi Başlangıcı"
                />
                <DateInput
                  value={filters.lastPaymentTryEnd || ""}
                  setValue={(e) => setFilters({ ...filters, lastPaymentTryEnd: e })}
                  placeholder="Son Ödeme Denemesi Bitişi"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <TextInput
                  value={filters.name}
                  setValue={(e) => setFilters({ ...filters, name: e })}
                  placeholder="İsim"
                />
                <TextInput
                  value={filters.surname}
                  setValue={(e) => setFilters({ ...filters, surname: e })}
                  placeholder="Soyisim"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <TextInput
                  value={filters.id_number}
                  setValue={(e) => setFilters({ ...filters, id_number: e })}
                  placeholder="TC No"
                />
                <div className="relative w-full rounded-2xl bg-gray-100 border border-gray-200 focus-within:border-blue-500">
                  <label
                    className={`absolute left-4 top-4 transition-all duration-200 transform pointer-events-none ${
                      filters.status
                        ? "-translate-y-3 text-xs text-gray-600"
                        : "text-base text-gray-400"
                    } peer-focus:-translate-y-3 peer-focus:text-xs peer-focus:text-gray-600`}
                  >
                    Durum Seçiniz
                  </label>
                  <select
                    className="peer w-full bg-transparent text-gray-700 pt-6 pb-2 px-4 focus:outline-none"
                    value={filters.status}
                    onChange={(e) => handleChange("status", e.target.value)}
                  >
                    <option value=""></option>
                    {statusOptions
                      .filter((option) => option !== "")
                      .map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div
              className="flex flex-row justify-between w-full mt-24 p-4 space-x-24"
              style={{
                boxShadow: "0px -12px 20px -10px rgba(0, 0, 128, 0.1)",
              }}
            >
              <button className="text-blue h-12 rounded-full" onClick={handleClear}>
                Temizle
              </button>
              <button
                className="text-blue bg-blue-100 h-12 px-4 rounded-full"
                onClick={() => {
                  handleFetchData()
                  onClose()
                }}
              >
                <span>Uygula</span>
              </button>
            </div>
          </Modal>
        </div>
      )}
    </>
  )
}

export default Filters
